"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.spot = exports.CaseStudyComponent = void 0;
const app_1 = require("app");
class CaseStudyComponent extends app_1.Component {
    constructor() {
        super(...arguments);
        this.selector = '.case-study';
        this.titleSelector = '.card__title';
    }
    OnInit() {
        $(this.el[0].querySelector(this.titleSelector)).ellipsis({
            lines: 2,
            ellipClass: 'ellip',
            responsive: true,
        });
    }
}
exports.CaseStudyComponent = CaseStudyComponent;
exports.spot = new CaseStudyComponent();
